import { useEffect, useRef } from "react";
export const useBuilderHeaderStyle = ({ headerPortalHeight, isVisible, isVisibleOverlay, isHidden, isOverlayHeader, isTransitionDisabled, styles, }) => {
    const headerRef = useRef(null);
    const isBuilderStyleSkipped = headerRef.current === null;
    useEffect(() => {
        const headerBuilderWrapper = document.querySelector('[builder-model="header"]');
        if (headerBuilderWrapper) {
            headerRef.current = headerBuilderWrapper;
            headerBuilderWrapper.classList.add(styles.headerPosition);
        }
    }, [headerPortalHeight, styles]);
    useEffect(() => {
        if (headerRef.current) {
            headerRef.current.classList.toggle(styles.hidden, isHidden);
            headerRef.current.classList.toggle(styles.visible, isVisible);
            headerRef.current.classList.toggle(styles.fixed, isOverlayHeader);
            headerRef.current.classList.toggle(styles.visibleAsOverlay, isVisibleOverlay);
            headerRef.current.classList.toggle(styles.transitionDisabled, isTransitionDisabled);
        }
    }, [isHidden, isOverlayHeader, isTransitionDisabled, isVisible, isVisibleOverlay, styles]);
    return isBuilderStyleSkipped;
};
//# sourceMappingURL=useBuilderHeaderStyle.js.map